import { useId } from 'react';
import { FlameSvg, FlameWrap } from './chatSelectedProfile.styles';
import { DEFAULT_LEVEL_COLOR, getFlamePalette } from './getFlamePalette';

const FlameIcon = ({
	lit = false,
	size = 'md',
	color = DEFAULT_LEVEL_COLOR,
	isLoading = false,
}) => {
	const gradientId = useId().replace(/:/g, '');
	const innerGradientId = `${gradientId}-inner`;
	const palette = getFlamePalette(color);
	const baseClassName = lit ? 'flame--lit' : 'flame--dim';
	const className = isLoading
		? `${baseClassName} flame--loading`
		: baseClassName;

	return (
		<FlameWrap>
			<FlameSvg
				className={className}
				viewBox='0 0 48 60'
				aria-hidden='true'
				$size={size}
				$color={palette.base}
			>
				<defs>
					<linearGradient id={gradientId} x1='8' y1='5' x2='39' y2='52'>
						<stop offset='0' stopColor={palette.outerStart} />
						<stop offset='0.46' stopColor={palette.outerMid} />
						<stop offset='1' stopColor={palette.outerEnd} />
					</linearGradient>
					<linearGradient id={innerGradientId} x1='18' y1='31' x2='30' y2='54'>
						<stop offset='0' stopColor={palette.innerStart} />
						<stop offset='0.55' stopColor={palette.innerMid} />
						<stop offset='1' stopColor={palette.innerEnd} />
					</linearGradient>
				</defs>
				<path
					className='flame__outer'
					d='M27.4 2.8c1 8.1-4.2 12.8-7.2 18.7-1.2-3.9-.5-7.2 1-10.5C12.8 17.7 6.4 26.7 6.8 37.1 7.2 48.8 16.1 57 27.1 57c10.7 0 18.1-8.5 17.6-19.3-.4-9-5.7-16.8-12-23.1.2 5.6-2.2 8.9-5.1 11.5 1.2-7.7 4.4-13.7-.2-23.3Z'
					style={{
						fill: lit ? `url(#${gradientId})` : 'none',
						fillOpacity: lit ? 0.32 : 0,
						stroke: lit ? `url(#${gradientId})` : 'currentColor',
					}}
					strokeWidth='2.1'
					strokeLinejoin='round'
					strokeLinecap='round'
				/>
				<path
					className='flame__inner'
					d='M26.8 31.1c.3 4.1-2.6 6.3-4.3 9.1-.7-2-.5-3.8.2-5.5-4.7 3.8-7.2 8.2-6.7 12.8.5 5.2 4.8 9.1 10.4 9.1 5.5 0 9.4-4 9.3-9.1-.1-4.8-3.5-9.8-8.9-16.4Z'
					style={{
						fill: lit ? `url(#${innerGradientId})` : 'none',
						fillOpacity: lit ? 0.82 : 0,
						stroke: lit ? `url(#${innerGradientId})` : 'currentColor',
					}}
					strokeWidth='1.8'
					strokeLinejoin='round'
					strokeLinecap='round'
				/>
				<path
					className='flame__shine'
					d='M14.2 37.3c-.4-5.2 2-10 5.1-13.8'
					fill='none'
					stroke={palette.shine}
					strokeWidth='1.5'
					strokeLinecap='round'
					opacity={lit ? 0.72 : 0}
				/>
			</FlameSvg>
		</FlameWrap>
	);
};

export default FlameIcon;
